import { FormMutationInterface } from "@kernel/form/interfaces/form-mutation.interface";
import { BILLING_ACCOUNT_FORM_DATA_SHAPE } from "@app/shared/billing-account/datashapes/billing-account.datashape";

export const updateBillingAccountMutationConfig: FormMutationInterface = {
  name: "mergeMyBillingAccount",
  paramName: "input",
  paramType: "BillingAccountInput!",
  select: [BILLING_ACCOUNT_FORM_DATA_SHAPE],
};
